__turbopack_context__.v({
  "container": "Contact-module__dhIxzq__container",
  "container__text": "Contact-module__dhIxzq__container__text",
  "container__title": "Contact-module__dhIxzq__container__title",
});
